import axios from "axios";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import { getToken, removeToken } from "@/utils/auth";

// create an axios instance
const service = axios.create({
  // baseURL: 'https://api.chayiji.net.cn/api', // url = base url + request url
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // baseURL: '/proxyApi',
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    // console.log( getToken())
    // do something before request is sent
    // console.log(store.getters.token)
    // config.headers['token'] = getToken() ? getToken():null
    if (getToken()) {
      //   // let each request carry token
      //   // ['X-Token'] is a custom headers key
      //   // please modify it according to the actual situation
      config.headers["token"] = getToken();
    }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = JSON.parse(JSON.stringify(response.data));
    // if the custom code is not 20000, it is judged as an error.
    if (res.errorCode && res.errorCode !== "200") {
      Message({
        message: res.errorMessage || "Error",
        type: "error",
        duration: 1 * 1000
      });
      if (res.errorCode === "10065") {
        return res;
      }
      if (res.errorCode === "10001") {
        return res;
      }
      if (res.errorCode === 500) {
        removeToken();
        store.dispatch("user/resetToken").then(() => {
          location.reload();
        });
      }
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm(
          "You have been logged out, you can cancel to stay on this page, or log in again",
          "Confirm logout",
          {
            confirmButtonText: "Re-Login",
            cancelButtonText: "Cancel",
            type: "warning"
          }
        ).then(() => {
          store.dispatch("user/resetToken").then(() => {
            location.reload();
          });
        });
      }
      return Promise.reject(new Error(res.errorMessage || "Error"));
    } else {
      // Message({
      //   message: res.msg || 'Error',
      //   type: 'error',
      //   duration: 1 * 1000
      // })
      return res;
    }
  },
  error => {
    // console.log('err' + error) // for debug
    Message({
      message: error || "出现错误，请稍后再试",
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);
export default service;



// WEBPACK FOOTER //
// ./src/api/index.js